import { createNestablePublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { ErrorBoundary } from 'react-error-boundary'
import { AppRouter } from '../AppRouter'
import { msalConfig } from '../auth-config'
import { queryClient } from '../clients/react-query-client'
import { ThemedErrorFallback } from '../components/ErrorFallback/ThemedErrorFallback'
import { AuthProvider, ThemeContextProvider } from '../providers'

import '../i18n'
import '../index.css'

// Initialize app when Office is ready
Office.onReady(async () => {
  const msalInstance = await createNestablePublicClientApplication(msalConfig)
  const container = document.getElementById('container')

  if (!container) {
    throw new Error('Container not found')
  }

  const root = createRoot(container)

  root.render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <ThemeContextProvider>
          <MsalProvider instance={msalInstance}>
            <AuthProvider>
              <ErrorBoundary FallbackComponent={ThemedErrorFallback} onError={console.error}>
                <AppRouter />
              </ErrorBoundary>
            </AuthProvider>
          </MsalProvider>
        </ThemeContextProvider>
        <ReactQueryDevtools initialIsOpen={false} buttonPosition="top-right" />
      </QueryClientProvider>
    </StrictMode>
  )
})
